import {
  Box,
  Button,
  Container,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Stack,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { CustomerDatabaseStore } from "../../../../store/main/CustomerDatabaseStore";
import { useEffect, useState } from "react";
import ReportScreen from "../../../../common/enums/ReportScreens";
import ReportFiltersComponent from "../ReportFiltersComponent";
import ReportFiltersLoading from "../ReportFiltersLoading";
import moment from "moment";
import { ReportFilters } from "../../../../domain/models/report-filters";
import RegionWisePOB from "./sub-component/RegionWisePOB";
import DataSummaryPOB from "./sub-component/DataSummaryPOB";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { DownloadJSON } from "../../../../domain/models/daily-visit-report/downloadJSON";
import * as XLSX from "xlsx";
import React from "react";
import { DailyPOBReportStore } from "../../../../store/main/DailyPOBReportStore";
import { TerritoryDataStore } from "../../../../store/main/TerritoryDataStore";
import { fetchMonthlyPOBOrdersDataType } from "../../../../domain/models/daily-pob-report/dailypobreport";
import { TerritoryData } from "../../../../domain/models/territory-data";
import { POBSummaryType } from "../../../../domain/models/daily-pob-report/type-wise-count-pob-summary";
import DailyPOBReportSummaryLoading from "../DailyPOBReportSummaryLoading";
import DailyPOBTabCalendarLoader from "../DailyPOBTabCalendar";
import CircularProgress from "@mui/material/CircularProgress";
import { ReportFiltersComponentStore } from "../../../../store/main/ReportFilterComponentStore";
import Roles from "../../../../common/enums/Roles";

type MonthlyPOBParams = {
  brand_ids?: string[];
  customer_type_id?: string;
  department_id?: string;
  ga_code?: string;
};

type SummaryParams = {
  month: string;
  year: number;
  brand_ids?: string[];
  department_id?: string;
  customer_type_id?: string;
  ga_code?: string;
};

const DailyPOBReportDesktop = () => {
  const {
    monthlyPOBOrdersData,
    FetchMonthlyPOBOrdersDataState,
    fetchMonthlyPOBOrdersData,
    typeWiseCountPOBSummaryData,
    TypeWiseCountPOBSummaryDataState,
    fetchTypeWiseCountPOBSummaryData,
  } = DailyPOBReportStore();

  const {
    fetchReportFiltersComponent,
    resetReportFiltersComponent,
    reportFiltersComponent,
  } = ReportFiltersComponentStore();

  const { userDetails, userRole, decodeToken } = CustomerDatabaseStore();
  const { zoneMasterData } = TerritoryDataStore();

  const currentDate = new Date();
  const [monthlyPOBOrders, setMontlyPOBOrders] =
    useState<fetchMonthlyPOBOrdersDataType | null>(null);
  const [month, setMonth] = useState<number>(currentDate.getMonth() + 1);
  const [year, setYear] = useState<number>(currentDate.getFullYear());
  const [value, setValue] = useState(
    monthlyPOBOrders?.monthlyOrderCounts[0]?.region[0]?.rbm_name || ""
  );
  const [downloadJson, setDownloadJson] = useState<DownloadJSON[]>([]);
  const [type, setType] = useState("rupee");
  const [open, setOpen] = useState<boolean>(false);
  const [pobSummary, setPobSummary] = useState<POBSummaryType | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [departmentId, setDepartmentId] = useState<string | null>(null);
  const [isTabLoading, setIsTabLoading] = useState(false);
  const [isCalendarLoading, setIsCalendarLoading] = useState(false);
  const [isExpandLoading, setIsExpandLoading] = useState(false);
  const [isRegionLoading, setIsRegionLoading] = useState(false);
  const [customerTypeId, setCustomerTypeId] = useState<string | null>(null);
  const [regionGACode, setRegionGACode] = useState<string>("");
  const [selectedZoneGACode, setSelectedZoneGACode] = useState<string>("");

  const fetchCalendarData = async () => {
    try {
      setMonth(month);
      setYear(year);
      let params = {
        brand_ids: [],
        customer_type_id: null,
        department_id: null,
        ga_code: null,
      };
      setIsCalendarLoading(true);
      setIsTabLoading(true);
      setIsExpandLoading(true);
      const monthlyPOBOrdersCalendarData = await fetchMonthlyPOBOrdersData(
        month,
        year,
        params
      );
      if (monthlyPOBOrdersCalendarData.success) {
        setIsCalendarLoading(false);
        setIsTabLoading(false);
        setIsExpandLoading(false);
        setMontlyPOBOrders(monthlyPOBOrdersCalendarData);
        setRegionGACode(
          monthlyPOBOrdersCalendarData?.monthlyOrderCounts[0]?.region[0]?.region_ga_code
        );
      }
    } catch (error) {
      setLoading(false);
      setIsCalendarLoading(true);
      setIsTabLoading(true);
      setIsExpandLoading(true);
    }
  };

  const summaryApi = async (summaryParams: any) => {
    try {
      setLoading(true);
      const typeWiseSummary = await fetchTypeWiseCountPOBSummaryData(
        summaryParams
      );

      if (typeWiseSummary.success) {
        setPobSummary(typeWiseSummary.pob_summary);
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    decodeToken();
    fetchCalendarData();
  }, []);

  


 const fetchRegionGaCodeData = async () => {
   try {
     setLoading(true);
     const monthString = month.toString().padStart(2, "0");
     let summaryParams = {
       month: monthString,
       year: year,
       ...(customerTypeId && { customer_type_id: customerTypeId ?? null }),
       brand_ids: reportFiltersComponent.brandType ?? null,
       department_id: reportFiltersComponent.department ?? null,

       ga_code: userRole.role === Roles.AREA_MANAGER ? null : regionGACode,
     };
     await summaryApi(summaryParams);
   } finally {
     setLoading(false);
   }
 };


  useEffect(() => {
    if (regionGACode && (!open || userRole.role === Roles.AREA_MANAGER)) {
      fetchRegionGaCodeData();
    }
  }, [
    regionGACode,
    month,
    year,
    customerTypeId,
    reportFiltersComponent.brandType,
    reportFiltersComponent.department,
  ]);

  useEffect(() => {
    if (monthlyPOBOrders && monthlyPOBOrders.monthlyOrderCounts.length > 0) {
      const initialRegion = monthlyPOBOrders.monthlyOrderCounts[0]?.region.find(
        (region) => region.region_ga_code === "newValue"
      );
      if (initialRegion) {
        setValue(initialRegion.region_ga_code);
      } else {
        setValue(
          monthlyPOBOrders?.monthlyOrderCounts[0]?.region[0]?.region_ga_code
        );
      }
    }
  }, [monthlyPOBOrders]);

  const handleChange = async (newValue: string) => {
    setValue(newValue);
    setDownloadJson([]);
    const monthString = month.toString().padStart(2, "0");
    let summaryParams: SummaryParams = {
      month: monthString,
      year: year,
      customer_type_id: reportFiltersComponent.customerType ?? null,
      department_id: reportFiltersComponent.department ?? null,
      brand_ids: reportFiltersComponent.brandType ?? null,
    };
    if (newValue && (!open || userRole.role === Roles.AREA_MANAGER))
      summaryParams.ga_code = newValue;
    summaryApi(summaryParams);
  };

  const changeExpandAll = async () => {
    setIsRegionLoading(true);
    setDownloadJson([]);
    setOpen(!open);
    setMonth(month);
    setYear(year);

    const monthString = month.toString().padStart(2, "0");

    if (!open || userRole.role === Roles.AREA_MANAGER) {
      setValue(
        monthlyPOBOrders?.monthlyOrderCounts[0]?.region[0]?.region_ga_code ?? ""
      );
      let summaryParams: SummaryParams = {
        month: monthString,
        year: year,
        customer_type_id: reportFiltersComponent.customerType ?? null,
        department_id: reportFiltersComponent.department ?? null,
        brand_ids: reportFiltersComponent.brandType ?? null,
        ...(selectedZoneGACode && { ga_code: selectedZoneGACode ?? null }),
      };
      summaryApi(summaryParams);
    } else {
      setValue(
        monthlyPOBOrders?.monthlyOrderCounts[0]?.region[0]?.region_ga_code ?? ""
      );
      let summaryParams: SummaryParams = {
        month: monthString,
        year: year,
        ga_code: regionGACode,
        customer_type_id: reportFiltersComponent.customerType ?? null,
        department_id: reportFiltersComponent.department ?? null,
        brand_ids: reportFiltersComponent.brandType ?? null,
      };
      summaryApi(summaryParams);
    }
    await new Promise((resolve) => setTimeout(resolve, 1000));
    setIsRegionLoading(false);
  };

  const downloadFile = () => {
    const reversedDownloadJson = downloadJson.slice().reverse();
    const headers = [
      "role",
      "user",
      "territory",
      "dailyPOBTarget",
      "percentageToPOBTarget",
      "total",
      ...Object.keys(reversedDownloadJson[0]).filter(
        (key) => !["role", "user", "territory", "total"].includes(key)
      ),
    ];
    const ws = XLSX.utils.json_to_sheet(reversedDownloadJson, {
      header: headers,
    });

    const colWidths = headers.map((header) => ({ wch: header.length + 5 }));
    ws["!cols"] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, "output.xlsx");
  };

  const filterData = async (filter: ReportFilters) => {
    let selectedGaCode = {} as TerritoryData | undefined;

    if (filter.zone.length > 0) {
      selectedGaCode = zoneMasterData.find(
        (item) => item.id.toString() === filter.zone[0]
      );
      setSelectedZoneGACode(selectedGaCode ? selectedGaCode.ga_code : "");
    } else {
      setSelectedZoneGACode("");
    }

    let params: MonthlyPOBParams = {};
    if (filter.brandType) params.brand_ids = filter.brandType ?? null;
    if (filter.customerType) {
      params.customer_type_id = filter.customerType;
      setCustomerTypeId(filter.customerType);
    } else {
      setCustomerTypeId(null);
    }
    if (filter.department) params.department_id = filter.department ?? null;
    if (selectedGaCode?.ga_code) params.ga_code = selectedGaCode.ga_code;

    setDepartmentId(params.department_id ?? null);

    const month = parseInt(moment(filter.date?.toString()).format("MM"));
    const year = parseInt(moment(filter.date?.toString()).format("YYYY"));

    setMonth(month);
    setYear(year);

    const monthString = month.toString().padStart(2, "0");

    let summaryParams: SummaryParams = {
      month: monthString,
      year: year,
    };
    if (filter.brandType) summaryParams.brand_ids = filter.brandType ?? null;
    if (filter.department)
      summaryParams.department_id = filter.department ?? null;
    if (filter.customerType) {
      summaryParams.customer_type_id = filter.customerType;
      setCustomerTypeId(filter.customerType);
    } else {
      setCustomerTypeId(null);
    }

    try {
      setLoading(true);
      setIsTabLoading(true);
      setIsCalendarLoading(true);
      setIsExpandLoading(true);

      const monthlyPOBOrdersCalendarData = await fetchMonthlyPOBOrdersData(
        month,
        year,
        params
      );
      if (monthlyPOBOrdersCalendarData.success) {
        if (!open || userRole.role === Roles.AREA_MANAGER) {
          summaryParams.ga_code =
            monthlyPOBOrdersCalendarData?.monthlyOrderCounts[0]?.region[0]
              ?.region_ga_code ?? null;
        } else {
          if (selectedGaCode?.ga_code)
            summaryParams.ga_code = selectedGaCode.ga_code;
          summaryApi(summaryParams);
        }
        setIsCalendarLoading(false);
        setMontlyPOBOrders(monthlyPOBOrdersCalendarData);
        setRegionGACode(
          monthlyPOBOrdersCalendarData?.monthlyOrderCounts[0]?.region[0]?.region_ga_code
        );
      }
    } finally {
      setLoading(false);
      setIsTabLoading(false);
      setIsCalendarLoading(false);
      setIsExpandLoading(false);
    }
  };

  const clearData = async () => {
    const month = currentDate.getMonth() + 1;
    const year = currentDate.getFullYear();
    setMonth(month)
    setYear(year)
    const params = {
      brand_ids: [] as string[],
      customer_type_id: null,
      department_id: null,
      ga_code: null,
    };
    try {
      setLoading(true);
      setIsTabLoading(true);
      setIsCalendarLoading(true);
      setIsExpandLoading(true);

      const monthlyPOBOrders = await fetchMonthlyPOBOrdersData(
        month,
        year,
        params
      );
      if (monthlyPOBOrders.success) {
        setMontlyPOBOrders(monthlyPOBOrders);
      }
      const monthString = month.toString().padStart(2, "0");

      if (!open || userRole.role === Roles.AREA_MANAGER) {
        let summaryParams: SummaryParams = {
          month: monthString,
          year: year,
          ga_code: regionGACode ?? null,
        };
        summaryApi(summaryParams);
      } else {
        let summaryParams: SummaryParams = {
          month: monthString,
          year: year,
        };
        summaryApi(summaryParams);
      }
    } catch (error) {
    } finally {
      setLoading(false);
      setIsTabLoading(false);
      setIsCalendarLoading(false);
      setIsExpandLoading(false);
    }
  };

  const radioType = {
    border: "1px solid lightGrey",
    borderRadius: "10px",
    paddingRight: "6px",
    margin: "6px",
  };

  const applyRadioFilter = (e: any) => {
    setType(e.target.value);
  };

  return (
    <>
      <Box display="flex" justifyContent="space-between" gap={1}>
        <Typography variant="h5" fontWeight={550}>
          Daily POB Reports
        </Typography>
        <Typography sx={{ color: "red", padding: "2px", fontWeight: "bold" }}>
          Note: For Rupees the Total Value Column is in Lakhs
        </Typography>
      </Box>

      {Object.keys(userDetails).length > 0 ? (
        <ReportFiltersComponent
          type={ReportScreen.DAILY_POB_REPORT}
          successCallback={filterData}
          clearSuccessCallBack={clearData}
          userRole={userRole.role}
          userDetails={userDetails}
          gridColumns={24}
          territoryMultiSelect={false}
        />
      ) : (
        <ReportFiltersLoading />
      )}

      <Stack direction={"row"} gap={4} alignItems={"center"}>
        {userRole.role !== Roles.AREA_MANAGER && (
          <Button
            variant="contained"
            sx={{ width: "150px", height: "37px" }}
            onClick={changeExpandAll}
            endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          >
            {open ? "Collapse" : "Expand All"}
          </Button>
        )}

        <Button variant="contained" onClick={downloadFile}>
          Download
        </Button>
        <Stack>
          <FormControl>
            <RadioGroup row onChange={(e) => applyRadioFilter(e)} value={type}>
              <FormControlLabel
                value={"rupee"}
                sx={radioType}
                label={<Typography variant="caption">Rupees</Typography>}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                      },
                    }}
                  />
                }
              />
              <FormControlLabel
                value={"quantity"}
                sx={radioType}
                label={<Typography variant="caption">Quantity</Typography>}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                      },
                    }}
                  />
                }
              />
              <FormControlLabel
                value={"order_count"}
                sx={radioType}
                label={<Typography variant="caption">Order Count</Typography>}
                control={
                  <Radio
                    sx={{
                      "& .MuiSvgIcon-root": {
                        fontSize: 16,
                      },
                    }}
                  />
                }
              />
            </RadioGroup>
          </FormControl>
        </Stack>
      </Stack>

      {open ? (
        <Stack gap={3} py={1} borderRadius={3}>
          <>
            {isExpandLoading || loading ? (
              <>
                <DailyPOBReportSummaryLoading />
                <DailyPOBTabCalendarLoader type="expandCalendar" />
              
              </>
            ) : (
              <>
            
                {pobSummary && <DataSummaryPOB pobSummary={pobSummary} />}
                {monthlyPOBOrders?.monthlyOrderCounts?.map((zone, key) => (
                  <React.Fragment key={key}>
                    {zone.region.map((region, key) => (
                      <Stack gap={3} key={key}>
                        <Typography variant="h6">{region.rbm_name}</Typography>
                        {isRegionLoading ? (
                          <>                      
                            <CircularProgress />
                          </>
                        ) : (
                          <RegionWisePOB
                            data={region}
                            month={month}
                            year={year}
                            type={type}
                            departmentId={departmentId}
                            downloadJSON={downloadJson}
                            customerTypeId={customerTypeId}
                          />
                        )}
                      </Stack>
                    ))}
                  </React.Fragment>
                ))}
              </>
            )}
          </>
        </Stack>
      ) : (
        <Stack gap={1} py={1} borderRadius={3}>
          <TabContext value={value}>
            {isTabLoading ? (
              <DailyPOBTabCalendarLoader type="tab" />
            ) : userRole.role !== Roles.AREA_MANAGER ? (
              <TabList sx={{ display: "flex", overflow: "auto" }}>
                <Box
                  sx={{
                    display: "flex",
                    overflowX: "auto",
                    padding: "10px",
                    marginBottom: "10px",
                    "&::-webkit-scrollbar": {
                      height: "4px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "rgba(0, 0, 0, 0.2)",
                      borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  {monthlyPOBOrders?.monthlyOrderCounts.map(
                    (orderCount, orderIndex) => (
                      <React.Fragment key={orderIndex}>
                        {orderCount.region.map((region, regionIndex) => (
                          <Box
                            key={regionIndex}
                            sx={{
                              borderBottom:
                                value === region.region_ga_code
                                  ? "2px solid blue"
                                  : "none",
                              minWidth: "auto",
                            }}
                          >
                            <Tab
                              label={region.rbm_name}
                              value={region.region_ga_code}
                              onClick={() => {
                                handleChange(region.region_ga_code);
                              }}
                            />
                          </Box>
                        ))}
                      </React.Fragment>
                    )
                  )}
                </Box>
              </TabList>
            ) : (
              <></>
            )}
            {loading ? (
              <DailyPOBReportSummaryLoading />
            ) : (
              pobSummary && <DataSummaryPOB pobSummary={pobSummary} />
            )}

            {isCalendarLoading ? (
              <DailyPOBTabCalendarLoader type="calendar" />
            ) : (
              monthlyPOBOrders?.monthlyOrderCounts.map(
                (orderCount, orderIndex) => (
                  <Stack key={orderIndex}>
                    {orderCount.region.map((region, regionIndex) => (
                      <TabPanel
                        value={region.region_ga_code}
                        key={`${orderIndex}-${regionIndex}`}
                      >
                        <RegionWisePOB
                          data={region}
                          month={month}
                          year={year}
                          type={type}
                          departmentId={departmentId}
                          downloadJSON={downloadJson}
                          customerTypeId={customerTypeId}
                        />
                      </TabPanel>
                    ))}
                  </Stack>
                )
              )
            )}
          </TabContext>
        </Stack>
      )}
    </>
  );
};

export default DailyPOBReportDesktop;
